import { getUserTenant } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';

// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum Tenant {
    EU = 'EU',
    BRAZIL = 'BRAZIL',
    SOUTH_KOREA = 'SOUTH_KOREA',
    SOUTH_AFRICA = 'SOUTH_AFRICA',
}

export const getTenant = (state: RootState): Tenant => {
    const userTenant = getUserTenant(state)?.split('.')[0];
    switch (userTenant) {
        case 'rio-brazil':
            return Tenant.BRAZIL;
        case 'rio-southkorea':
            return Tenant.SOUTH_KOREA;
        case 'rio-southafrica':
            return Tenant.SOUTH_AFRICA;
        default:
            return Tenant.EU;
    }
};

export const isEuropeanTenant = (state: RootState) => getTenant(state) === Tenant.EU;
export const isKoreanTenant = (state: RootState) => getTenant(state) === Tenant.SOUTH_KOREA;
